// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3BdWR","obliqueLineWrap":"membershipbadge_obliqueLineWrap__NtLZ0","obliqueLine":"membershipbadge_obliqueLine__1AiNk"};